module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("es6k6"))).then(() => parcelRequire('hEqeo'));